import formatString from 'format-string-by-pattern'

export const parseCpf = anyString => {
  if (anyString) {
    const onlyNumbers = anyString.replace(/[^\d]/g, '')
    return formatString('000.000.000-00')(onlyNumbers)
  }
}

export const parseCnpj = anyString => {
  if (anyString) {
    const onlyNumbers = anyString.replace(/[^\d]/g, '')
    return formatString('00.000.000/0000-00')(onlyNumbers)
  }
}

export const parseCpfOrCnpj = anyString => {
  if (anyString) {
    const onlyNumbers = anyString.replace(/[^\d]/g, '')
    if (onlyNumbers.length < 12) {
      return formatString('000.000.000-00')(onlyNumbers)
    }
    return formatString('00.000.000/0000-00')(onlyNumbers)
  }
}

export const parseRg = anyString => {
  if (anyString) {
    const onlyNumbers = anyString.replace(/[^\d]/g, '')
    return formatString('0000000000-0')(onlyNumbers)
  }
}

export const parseTelefone = anyString => {
  if (anyString) {
    const onlyNumbers = anyString.replace(/[^\d]/g, '')
    if (onlyNumbers.length < 11) {
      return formatString('(00) 0000-0000')(onlyNumbers)
    }
    if (onlyNumbers.length < 12) {
      return formatString('(00) 00000-0000')(onlyNumbers)
    }
    return formatString('+00 (00) 00000-0000')(onlyNumbers)
  }
}

export const parsePlaca = anyString => {
  if (anyString) {
    return formatString('XXX-XXXX')(anyString).toUpperCase()
  }
}

export const parseCep = anyString => {
  if (anyString) {
    return formatString('00000-000')(anyString)
  } else {
    return ''
  }
}

export const parseAno = value => {
  if (!value) return ''
  if (value.toString().length > 4) {
    return value.slice(0, 4)
  }
  return value
}

export const parseOnlyNumbers = anyString => {
  if (anyString) {
    return anyString.replace(/[^\d]/g, '')
  }
}

export const parseObjectKeysToString = obj => {
  return Object.keys(obj).map(f => {
    const splited = f
      .split(/(?=[A-Z])/)
      .map(s => s[0].toUpperCase() + s.slice(1))
    return splited.join(' ')
  })
}
